import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { QuoteCTA } from "@/components/QuoteCTA";
import { PackageCheck, ClipboardCheck, Truck, Boxes, Workflow, MessagesSquare } from "lucide-react";

const sections = [
  { icon: ClipboardCheck, title: "Dependable Component Philosophy", desc: "We focus on sourcing components positioned for dependable, durable performance." },
  { icon: PackageCheck, title: "Inspection & Process", desc: "Parts are checked against the requested specification before dispatch." },
  { icon: Boxes, title: "Packaging", desc: "Components are prepared and packaged for transit." },
  { icon: Truck, title: "Logistics", desc: "Coordinated dispatch and international supply support for export orders." },
  { icon: Workflow, title: "Supply Workflow", desc: "A structured workflow from enquiry to confirmed supply." },
  { icon: MessagesSquare, title: "Commercial Enquiry Process", desc: "A professional B2B enquiry and quotation process." },
];

export default function QualitySupply() {
  return (
    <>
      <PageHero kicker="Quality & Supply" title="Dependable Components, Clear Supply"
        text="Our approach to component selection, preparation and international supply."
        image="https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />

      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <SectionHeading kicker="Our Approach" title="Built for Dependable Supply"
            text="These sections describe our positioning and process, with a focus on dependable sourcing and clear communication." />
          <div className="mt-14 grid gap-px border border-[#E3E8EF] bg-[#E3E8EF] sm:grid-cols-2 lg:grid-cols-3">
            {sections.map((s, i) => (
              <Reveal key={s.title} delay={(i % 3) * 0.08} className="group bg-white p-8 transition-colors duration-300 hover:bg-ink">
                <s.icon className="w-9 h-9 text-amber-hover" strokeWidth={1.5} />
                <h3 className="mt-5 font-display uppercase text-xl tracking-wide text-ink group-hover:text-white transition-colors">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted group-hover:text-white/70 transition-colors">{s.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <QuoteCTA />
    </>
  );
}
